import ManualBillingList from '@/components/ManualBilling/ManualBillingList'
import ManualBillingForm from '@/components/ManualBilling/ManualBillingForm'
import ManualBillingDetail from '@/components/ManualBilling/ManualBillingDetail'

let ManualBillingRouter = [{
  path: '/manual_billing',
  name: 'ManualBillingList',
  component: ManualBillingList,
  meta: {
    title: 'Facturation manuelle',
    requiresAuth: true,
    authorizations: ['manual-billing_index', 'desktop_access']
  }
}, {
  path: '/manual_billing/new',
  name: 'ManualBillingNew',
  component: ManualBillingForm,
  meta: {
    title: 'Nouvelle facturation manuelle',
    requiresAuth: true,
    authorizations: ['manual-billing_new', 'desktop_access']
  }
}, {
  path: '/manual_billing/:id/edit',
  name: 'ManualBillingEdit',
  component: ManualBillingForm,
  meta: {
    title: 'Modifier une facturation manuelle',
    requiresAuth: true,
    authorizations: ['manual-billing_edit', 'desktop_access']
  }
}, {
  path: '/manual_billing/:id',
  name: 'ManualBillingDetail',
  component: ManualBillingDetail,
  meta: {
    title: 'Fiche facturation manuelle',
    requiresAuth: true,
    authorizations: ['manual-billing_show', 'desktop_access']
  }
}]

export default ManualBillingRouter



// WEBPACK FOOTER //
// ./src/components/ManualBilling/router.js